import {BaseContainerModel} from '../../base-container.model';
import {Bl_inv_stock_take_session_hdr_RowClass} from '../../../dbschema/bl_inv_stock_take_session_hdr.model';
import {Bl_inv_stock_take_session_ext_RowClass} from '../../../dbschema/bl_inv_stock_take_session_ext.model';

export class StockTakeSessionHeaderModel extends BaseContainerModel {
  bl_inv_stock_take_session_hdr: Bl_inv_stock_take_session_hdr_RowClass = new Bl_inv_stock_take_session_hdr_RowClass();
  bl_inv_stock_take_session_exts: Bl_inv_stock_take_session_ext_RowClass[] = [];
}
